import { Link } from "react-router";
import "./Error502Page.scss";

export default function Error404Page() {
    return (
        <section className="error502">
            <img
                className="error502__target"
                src="/ErrorPages/502.svg"
                alt="502"
            />

            <div className="error502__content">
                <h1 className="error502__title">
                    УПС,<br />
                    ЧТО-ТО СЛОМАЛОСЬ
                </h1>

                <p className="error502__description">
                    МЫ УЖЕ ЗНАЕМ О ПРОБЛЕМЕ И ИСПРАВЛЯЕМ
                </p>

                <Link className="error502__button" to="/">
                    На главную
                </Link>
            </div>

            <div className="error502__figures">
                <img
                    className="error502__bigMan"
                    src="/ErrorPages/bigman502.svg"
                    alt=""
                />

                <img
                    className="error502__smallMan"
                    src="/ErrorPages/smallman502.svg"
                    alt=""
                />
            </div>
        </section>
    );
}